import { f as r } from "./function-uncurry-this.js";
import { i as o } from "./is-callable.js";
import { s } from "./shared-store.js";
var t = r(Function.toString);
o(s.inspectSource) || (s.inspectSource = function (r) {
  return t(r);
});
var i = s.inspectSource;
export { i };